module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/55c1b3687521318ec710907ff62b57f5.png";